import firebase from 'firebase'

export const autoUploadRef = (uid: string) => firebase.firestore().collection('autoUpload').doc(uid)
